import { BASE_URL } from "../../../../App/Configs/AppConfig";
import ApiHelper from "../../../../App/Utils/APIHelper";
import { URLS } from "../../../constants";

export default class AN13DataProvider {
  apiHelper = new ApiHelper(BASE_URL);

  registration_customer_api = async (values) =>
    await this.apiHelper.apiCall(URLS.CUSTOMER_REGISTRATION, "POST", values);

  validate_emp_code_api = async (emp_code) =>
    await this.apiHelper.apiCall(
      URLS.VALIDATE_EMP_CODE + emp_code,
      "GET",
      null
    );

  // METHOD TO GET DEFAULT FME VALUES
  get_default_fme_values = async (id, acc_group) =>
    await this.apiHelper.apiCall(
      URLS.GET_DEFAULT_FME_VALUES +
        (acc_group !== null && acc_group !== undefined && acc_group !== ""
          ? "?acc_group=" + acc_group
          : ""),
      "GET",
      null
    );
}
